import React, { useEffect } from "react"
import Image from "../../../UI/Image"
import classNames from "classnames"
import { useIntl } from "gatsby-plugin-intl"
import Glide from "@glidejs/glide"

import * as styles from "./StorySlider.module.scss"

const storiesList = [
  {
    year: "2015",
    img: "/images/our-story/2015.png",
    text: "story.timeline.point-1.text",
  },
  {
    year: "2015–2016",
    img: "/images/our-story/2015-2016.png",
    text: "story.timeline.point-2.text",
  },
  {
    year: "2017-2018",
    img: "/images/our-story/2017-2018.png",
    text: "story.timeline.point-3.text",
  },
  { img: "/images/our-story/2017-2018-2.png" },
  {
    year: "2018-2020",
    img: "/images/our-story/2018-2020.png",
    text: "story.timeline.point-5.text",
  },
  { img: "/images/our-story/2021.png" },
  {
    year: "2021-2022",
    img: "/images/our-story/2021-2022.png",
    text: "story.timeline.point-7.text",
  },
  { img: "/images/our-story/2023.png" },
  {
    year: "2022-2024",
    img: "/images/our-story/2022-2024.png",
    text: "story.timeline.point-9.text",
  },
  {
    year: "present",
    img: "/images/our-story/nowadays.png",
    text: "story.timeline.point-10.text",
  },
]

const StorySlider = () => {
  const intl = useIntl()

  useEffect(() => {
    if (
      styles?.storySlider &&
      document.querySelector(`.${styles.storySlider}`)
    ) {
      const glide = new Glide(`.${styles.storySlider}`, {
        // type: "carousel",
        keyboard: false,
        autoplay: false,
        hoverpause: false,
        animationTimingFunc: "linear",
        dragThreshold: 60,
        animationDuration: 150,
        peek: {
          before: 0,
          after: 260,
        },
        startAt: 0,
        perView: 3,
        gap: 72,
        direction: intl.locale === "ar" ? "rtl" : "ltr",
        breakpoints: {
          1200: {
            perView: 2,
            peek: {
              before: 0,
              after: 220,
            },
            gap: 48,
          },
          800: {
            perView: 2,
            peek: {
              before: 0,
              after: 0,
            },
            gap: 24,
          },
          500: {
            perView: 1,
            peek: {
              before: 0,
              after: 100,
            },
          },
          400: {
            perView: 1,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      })
      glide.mount()
    }
  })

  const storyClasses = classNames(styles.storySlider, "glide")
  const storyWrapperClasses = classNames(styles.wrapper, "glide__track")
  const storyListClasses = classNames(styles.list, "glide__slides")
  const storyItemClasses = classNames(styles.item, "glide__slide")

  return (
    <div className={storyClasses}>
      <div className={storyWrapperClasses} data-glide-el="track">
        <ul className={storyListClasses}>
          {storiesList.map((item, index) => (
            <li key={index} className={storyItemClasses}>
              <Image
                className={styles.img}
                src={item.img}
                alt={item.year}
                width={384}
              />
              {item.year && <h3>{item.year}</h3>}
              {item.text && <p>{intl.formatMessage({ id: item.text })}</p>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default StorySlider
